/**
 * „Mit kérnek tőlem" — betöltés és újratöltés.
 *
 * A HIBÁT KI KELL MONDANI. Egy üres listát mutatva a képernyő azt állítaná,
 * hogy nincs bekérve semmi — az ügyfél megnyugodna, és a hiány ott maradna.
 * Ugyanaz a bukásmód, amit a könyvelői hiánylista „hamis nullája" (`2.4d`), a
 * másik oldalról nézve.
 *
 * ── A KÉSVE ÉRKEZŐ VÁLASZ ────────────────────────────────────────────
 *
 * A NEMZEDÉK-SZÁMLÁLÓ nem óvatoskodás. A feltöltés után újratöltünk, és a
 * lassabb, KORÁBBI kérés simán befuthat a frissebb UTÁN — mobilhálózaton ez a
 * normális, nem a kivétel. Egy sima „lemondtam?" jelző csak a lecsatolást
 * kezelné; ez azt is, hogy melyik válasz a legfrissebb. Enélkül a képernyő
 * visszaugrana a feltöltés előtti állapotra, és az ügyfél újra feltöltene.
 */

import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '@/lib/api-client';
import type { ClientRequestList } from './types';

export type RequestsStatus = 'loading' | 'failed' | 'ready';

export interface RequestsState {
  status: RequestsStatus;
  list: ClientRequestList | null;
  reload: () => void;
}

export function useRequests(): RequestsState {
  const [list, setList] = useState<ClientRequestList | null>(null);
  const [status, setStatus] = useState<RequestsStatus>('loading');
  const generation = useRef(0);

  const reload = useCallback(() => {
    generation.current += 1;
    const mine = generation.current;

    void api<ClientRequestList>('/requests')
      .then((loaded) => {
        if (mine === generation.current) {
          setList(loaded);
          setStatus('ready');
        }
      })
      .catch(() => {
        if (mine === generation.current) {
          setStatus('failed');
        }
      });
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { status, list, reload };
}
